export default __webpack_public_path__ + "static/HeldaneDisplayWeb-Regular-9266c6be303b011dab2a1abb1708bb67.woff";